module.exports = __webpack_public_path__ + "images/with-the-spins-ddb39f4eb11c9eea29d99ead98652309.png";